import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { LIGHT_BLACK } from "../../utils/colors";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    justifyContent: "space-between",
    alignItems: "center",
    display: "flex",
    padding: theme.spacing(0, 4),
    height: theme.spacing(8),
    backgroundColor: "#FFF",
    boxShadow: "0px 0px 25px rgba(0, 0, 0, 0.15)",
  },
  rootLeft: {
    justifyContent: "space-between",
    display: "flex",
  },
  appButton: {
    margin: `0 ${theme.spacing(1)} !important`,
    color: `${LIGHT_BLACK} !important`,
    lineHeight: "26px",
    borderRadius: "0px !important",
    padding: `${theme.spacing(1.5, 1)} !important`,
  },
  appButtonActive: {
    color: "#0C20B5 !important",
    borderBottom: "3px solid #0C20B5 !important",
    borderRadius: "0px !important",
    padding: `${theme.spacing(1.5, 1)} !important`,
  },
  image: {
    width: theme.spacing(12),
    objectFit: "contain",
  },
  imageMarketing: {
    margin: theme.spacing(0, 2),
    width: theme.spacing(20),
  },
  btnOptions: {
    margin: `0 ${theme.spacing(1)} !important`,
    color: `${LIGHT_BLACK} !important`,
    lineHeight: "26px",
  },
  btn: {
    marginRight: `${theme.spacing(1)} !important`,
    lineHeight: "26px",
  },
  avatar: {
    cursor: "pointer",
  },
  iconBtn: {
    marginRight: `${theme.spacing(1)} !important`,
    color: `${LIGHT_BLACK} !important`,
  },
}));
